import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'
import type {
  ScriptedTestConfigParams,
  TestConfigInput,
  TestConfigInputResponse
} from '@eggplant/types'

interface Props {
  testConfigId: string
  children?: (data: TestConfigInput) => ReactElement
  onSuccess?: (data: TestConfigInput) => void
}

const getScriptedTestConfigParams = (data: TestConfigInputResponse) => {
  const { scripted_test_config_params } = data

  const newScriptedTestConfigParams = scripted_test_config_params === null
    ? null
    : Object.keys(scripted_test_config_params).map(
      (param, index) => ({
        name: param,
        value: Object.values(scripted_test_config_params)[index]
      }) as ScriptedTestConfigParams
    )

  return ({
    ...data,
    scripted_test_config_params: newScriptedTestConfigParams
  }) as TestConfigInput
}

const GetTestConfigRequest = ({ testConfigId, children, onSuccess }: Props) => {
  const url = TEST_CONFIG_SERVICE + '/test_configurations/' + testConfigId

  const handleOnSuccess = (data: TestConfigInputResponse) => {
    if (!onSuccess) return

    const newData = getScriptedTestConfigParams(data)

    onSuccess(newData)
  }

  const handleOnRenderChildren = (data: TestConfigInputResponse) => {
    if (!children) return undefined

    const newData = getScriptedTestConfigParams(data)

    return children(newData)
  }

  return (
    <AuthenticatedDataRequest
      children={handleOnRenderChildren}
      method='get'
      onSuccess={handleOnSuccess}
      url={url}
    />
  )
}

export default GetTestConfigRequest
